import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useAppStore }   from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'

// The legacy portal's background polls (old/Skynet_ClientsWEB Main.vue): the permission list
// and the number of tasks waiting for the client's confirmation, both every 5 s. Started and
// stopped with the signed-in shell (layouts/Default.vue).
export const usePollStore = defineStore('poll', () => {
    const appStore   = useAppStore()
    const fetchStore = useFetchStore()

    // Badged on the Tasks group and its "In confirmation" row; hidden at 0.
    const tasksInConfirmation = ref(0)

    let timers: ReturnType<typeof setInterval>[] = []
    let running = false

    const updatePermissions = async () => {
        if (!appStore.isLoggedIn()) return
        const { statusCode, data } = await fetchStore.fetch('/permissions').get().json<number[]>()
        if (statusCode.value === 200 && data.value) appStore.setPermissions(data.value)
    }

    const updateTasksInConfirmation = async () => {
        if (!appStore.isLoggedIn()) return
        const { statusCode, data } = await fetchStore.fetch('/tasks/inConfirmation/num').get().json<number>()
        if (statusCode.value === 200 && data.value !== null) tasksInConfirmation.value = Number(data.value)
    }

    const start = () => {
        if (running) return
        running = true

        void updatePermissions()
        void updateTasksInConfirmation()

        timers = [
            setInterval(updatePermissions,         5000),
            setInterval(updateTasksInConfirmation, 5000),
        ]
    }

    const stop = () => {
        timers.forEach(clearInterval)
        timers = []
        running = false
    }

    return { tasksInConfirmation, start, stop, updatePermissions, updateTasksInConfirmation }
})
